export enum FeatureFlag {
  COST_PER_THOUSAND_ENABLED = 'COST_PER_THOUSAND_ENABLED',
  HOME_PAGE_V2_ENABLED = 'HOME_PAGE_V2_ENABLED'
};